let recaptchaCheckTimeout;

export async function RecaptchaVisibilityManager(to) {
    clearTimeout(recaptchaCheckTimeout);
    let recaptcha;
    do {
        await new Promise(resolve => setTimeout(resolve, 200));
        recaptcha = document.querySelector('.grecaptcha-badge');
    } while (!recaptcha);
    if (to.matched.some(record => record.meta.redirectIfLoggedIn)) {
        recaptcha.style.visibility = 'visible';
    }
    else {
        recaptcha.style.visibility = 'hidden';
    }
}


// WEBPACK FOOTER //
// ./src/router/recaptcha.js